module.exports = __webpack_public_path__ + "pcombinator.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/pcombinator.png
 ** module id = 88
 ** module chunks = 0
 **/